module.exports = __webpack_public_path__ + "assets/img/52b4-gq.svg";